var _style, _path, _path2, _g, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFDA44;}\n\t.st1{fill:#D80027;}\n\t.st2{fill:#338AF3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.6,138.6C471.7,115.7,456.2,94.2,437,75c-19.2-19.2-40.7-34.7-63.6-46.5L193,193L28.4,373.4 C40.3,396.3,55.8,417.8,75,437s40.7,34.7,63.6,46.5L319,319L483.6,138.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75,437c10.7,10.7,22.2,20.3,34.2,28.8l356.6-356.6c-8.4-12-18-23.5-28.7-34.2c-10.7-10.7-22.2-20.3-34.2-28.7 L46.2,402.8C54.7,414.8,64.2,426.3,75,437L75,437z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75,75C-5.8,155.7-21.3,277,28.4,373.4l345-345C277-21.3,155.7-5.8,75,75L75,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M437,437c80.8-80.8,96.3-202.1,46.5-298.4l-345,345C235,533.3,356.3,517.8,437,437z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.4,77.9l13.8,42.5h44.7l-36.2,26.3l13.8,42.5l-36.2-26.3l-36.2,26.3l13.8-42.5l-36.2-26.3h44.7L136.4,77.9z "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCd);
export default __webpack_public_path__ + "static/media/cd.051dfc089153306a33f8698060f7aa8e.svg";
export { ForwardRef as ReactComponent };